<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon"><svg-icon icon-class="404"></svg-icon></div>
      <div class="error-desc">抱歉，页面不存在</div>
      <div class="error-subdesc">您访问的页面可能已被删除、移动或输入了错误的地址</div>
      <div class="error-handle">
        <el-button type="primary" @click="goHome">返回首页</el-button>
        <el-button @click="goBack">返回上一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data:function() {
    return {

    }
  },
  created() {
  },
  methods: {
    goHome() {
      this.$router.push({ path: '/' });
    },
    goBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  padding: 20px;
}

.error-content {
  text-align: center;
  max-width: 600px;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 60px 40px;
  transition: all 0.3s ease;
}

.error-content:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.error-icon {
  width: 160px;
  height: 160px;
  margin: 0 auto 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-icon svg {
  width: 100%;
  height: 100%;
}

.error-desc {
  font-size: 24px;
  color: #333333;
  margin-bottom: 16px;
  font-weight: 500;
}

.error-subdesc {
  font-size: 16px;
  color: #666666;
  margin-bottom: 40px;
  line-height: 1.5;
}

.error-handle {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.error-handle .el-button {
  min-width: 140px;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .error-content {
    padding: 40px 30px;
    max-width: 90%;
  }

  .error-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 30px;
  }

  .error-desc {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .error-subdesc {
    font-size: 14px;
    margin-bottom: 30px;
  }

  .error-handle {
    gap: 16px;
  }

  .error-handle .el-button {
    min-width: 120px;
    padding: 8px 20px;
    font-size: 14px;
  }
}
</style>